import ActivityEdit from './ActivityEdit';
import ActivityList from './ActivityList';
import ActivityPage from './ActivityPage';
import { ReactComponent as ActivityIcon } from '../icons/main_menu/activities.svg';

const exports = {
    Page: ActivityPage,
    List: ActivityList,
    Edit: ActivityEdit,
    Icon: ActivityIcon,
};
export default exports;
